module.exports = __webpack_public_path__ + "static/media/ic_zoom_in.0eafbb61.svg";